// extracted by mini-css-extract-plugin
export default {"component":"ServiceSelectionCopy_component__ynw4n","neutral":"ServiceSelectionCopy_neutral__KfwQp","dark":"ServiceSelectionCopy_dark__FZQUd"};